var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content ofh"},[_c('demo-Header',{attrs:{"message":_vm.message}}),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"page-content"},[_c('router-view')],1)]),_vm._v(" "),_c('demo-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7c92dbad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/mainContent/index.vue
// module id = null
// module chunks = 